import { AvatarModel } from '../../components/Avatar';
import { NetworkPromise } from '@packages/dataFetch';

export enum EntityTypeIds {
	EMPLOYER = 18,
	AGENCY = 20,
	CANDIDATE = 95,
	COMMUNITY = 283,
	PLATFORM_USER = 2,
}

type BaseUserProps = {
	isInitialized: boolean;
	isPending: boolean;
	canViewProfile: boolean;
	customerName?: string;
	activeLanguageId?: number;
	avatar: AvatarModel;
	organizationTypeId?: EntityTypeIds;
	organizationName?: string;
	hasAcceptedCookie: boolean;
};

export type User = BaseUserProps &
	(
		| {
				isAuthenticated: true;
				id: number;
				email: string;
				formattedName: string;
				initials: string;
		  }
		| {
				isAuthenticated: false;
				id: never;
				email: never;
				formattedName: never;
				initials: never;
		  }
	);

export interface UserAPI {
	fetchUserContext: () => NetworkPromise<User>;
	tryFetchUserContext: () => NetworkPromise<User> | void;
	resetUserContextCache: { (): void };
	setUserAvatar: { (photoUrl: string): void };
	acceptCookie: () => void;
}
